import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import TestsmsIcon from "@mui/icons-material/Textsms";
import Button from "designSystem/components/button/Button";
import { grey } from "designSystem/styles/color";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import { Box, OverflowText } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import Placeholder from "designSystem/components/placeholder/Placeholder";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import MSTeamsNoChannelsIcon from "../icon/MSTeamsNoChannelsIcon";
import { useMSTeamsStore } from "./MSTeamsStore";

const ConnectToMSTeamsFirstTime: FunctionComponent = observer(() => {
	const locale = useLocale();
	const { routerStore } = useStore();
	const node = routerStore.locationNode;
	const resParams = [locale.type(node.$Type)];
	const { navigationToChannelSelection, userIsReadOnly } = useMSTeamsStore();

	return (
		<FlexRowCenter
			flexGrow={1}
			justifyContent="center"
			px={3}
		>
			{userIsReadOnly ? (
				<Placeholder
					subtitleProps={{ res: "MSTeamsNoChannelsForReadOnlyUserPlaceholderText", resParams }}
					titleProps={{ res: "NoChannelsForReadOnlyUserPlaceholderTitle" }}
				>
					{{ image: <MSTeamsNoChannelsIcon /> }}
				</Placeholder>
			)
				: (
					<Placeholder
						subtitleProps={{ res: "ConnectToMSTeamsPlaceholderText", resParams }}
						titleProps={{ res: "ConnectToMSTeamsPlaceholderTitle", resParams }}
					>
						{{
							actions:
							<Button
								design="primary"
								fullWidth
								hideOverflow
								onClick={navigationToChannelSelection}
							>
								<OverflowText res="ConnectToMSTeamsButton" resParams={resParams} />
							</Button>
							,
							image:
							<Box>
								<Box color={grey[100]} height={36}>
									<ChatBubbleIcon style={{ fontSize: 36 }} />
								</Box>
								<Box
									color={grey[300]}
									height={36}
									ml={9}
								>
									<TestsmsIcon style={{ fontSize: 36, transform: "rotateY(180deg)" }} />
								</Box>
							</Box>
							,
						}}
					</Placeholder>
				)}
		</FlexRowCenter>
	);
});

export default ConnectToMSTeamsFirstTime;